import { useFormContext } from "react-hook-form";
import useTeams from "../hooks/useTeams";
import { ProfileFormData } from "../pages/EditProfile"; // Import the shared form data type

const EditStats = () => {
  const { register, formState: { errors } } = useFormContext<ProfileFormData>();

  const { data: teams, isLoading: teamsLoading, error: teamsError } = useTeams();

  if (teamsLoading) return <div>Loading teams...</div>;
  if (teamsError) return <div>Error while loading teams.</div>;

  return (
    <>
      <h3 className="mb-3" style={{ color: "#ff8200" }}>
        Profile Information
      </h3>
      <hr style={{ borderColor: "#ff8200", marginBottom: "1.5rem" }} />

      <div className="mb-3">
        <label htmlFor="xp" className="form-label">XP:</label>
        <input
          type="number"
          id="xp"
          {...register("stats.xp", { valueAsNumber: true })}
          className={`form-control ${errors.stats?.xp ? "is-invalid" : ""}`}
          style={{
            backgroundColor: "#333633", color: "#c2c2c2", borderColor: "#4a4d4a",
          }}
        />
        <div className="invalid-feedback">{errors.stats?.xp?.message}</div>
      </div>

      <div className="mb-3">
        <label htmlFor="level" className="form-label">Level:</label>
        <input
          type="number"
          id="level"
          {...register("stats.level", { valueAsNumber: true })}
          className={`form-control ${errors.stats?.level ? "is-invalid" : ""}`}
          style={{
            backgroundColor: "#333633", color: "#c2c2c2", borderColor: "#4a4d4a",
          }}
        />
        <div className="invalid-feedback">{errors.stats?.level?.message}</div>
      </div>

      <div className="mb-3">
        <label htmlFor="team" className="form-label">Team:</label>
        <select
          id="team"
          {...register("stats.team", { valueAsNumber: true })}
          className={`form-select ${errors.stats?.team ? "is-invalid" : ""}`}
          style={{
            backgroundColor: "#333633", color: "#c2c2c2", borderColor: "#4a4d4a",
          }}
        >
          {teams?.map((team) => (
            <option key={team.id} value={team.id}>
              {team.name}
            </option>
          ))}
        </select>
        <div className="invalid-feedback">{errors.stats?.team?.message}</div>
      </div>
    </>
  );
};

export default EditStats;